<div id="slides">
    <div class="overlay">   
        <a class="ct-btn-scroll ct-js-btn-scroll" href="#portfolio"><img alt="Arrow Down Icon" src="../../assets/images/icons/white-down-arrow.png"></a>
    </div>
    <section class="view intro-video">
        <video poster="https://mdbootstrap.com/img/Photos/Others/background.jpg" playsinline="playsinline" autoplay="autoplay" [muted]="'muted'" loop="loop">
          <source src="https://res.cloudinary.com/kaushalshah1307/video/upload/v1596276202/Website_reel_8M_cniufq.mp4" type="video/mp4">
        </video>
    </section>
</div>